import $ from 'jquery';

((
    ($) => {

        if (typeof country_values === 'undefined') {
            return false;
        }

        let _source = $('.js-country-chain');
        let _target = $('.js-country-chain-target');
        if (!_source.length || !_target.length) {
            return;
        }

        const _emptyTarget = () => {
            _target.find('option').each(function () {
                if ($(this).attr('value').length) {
                    $(this).remove();
                }
            });
        };

        const _assignValues = (_key, _value = '') => {
            _emptyTarget();
            if (!_key.length) {
                return;
            }
            if (typeof country_values[_key] !== 'undefined') {
                $.each(country_values[_key], (key, value) => {
                    if (_value.length && key === _value) {
                        _target.append('<option selected value="' + key + '">' + value + '</option>');
                    } else {
                        _target.append('<option value="' + key + '">' + value + '</option>');
                    }
                });
            }
        };

        _source.change(function () {
            let _value = $(this).val();
            _assignValues(_value);
        });

        let _value = '';
        if (typeof _source.attr('data-area-value') !== 'undefined' && _source.attr('data-area-value').length) {
            _value = _source.attr('data-area-value');
        }
        _assignValues(_source.val(), _value);

    }
)(jQuery));